import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ForcePasswordGate({ children }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (user?.must_change_password && pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  return children;
}
